<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
export interface ProductBoxColoredProps {
    item: ProductBoxColored
    headingLevel: string
}
const props = defineProps<ProductBoxColoredProps>()

const { data, sendEvent } = useTracker()

const handleClick = (): void => {
    sendEvent({
        data: {
            ...data,
            title: props.item.title,
            click: props.item.cta_button.link,
        },
    })
}
</script>

<template>
  <article
    class="product-box-colored position-relative transition rounded px-4 px-md-6 pt-4 pb-10 h-100"
    :style="`--product-box-colored-bg-color: ${props.item.background_color}`"
  >
    <div class="d-flex justify-content-end gap-2 mb-3">
      <Label
        v-for="(tag, tagIndex) in props.item.tag"
        :key="`product-box-colored-tag-${tagIndex}`"
        :label="tag.name"
        :text-color="tag.color"
        :background-color="tag.background"
      />
    </div>
    <img
      v-if="props.item?.image?.path"
      class="mb-3"
      :src="props.item.image.path"
      loading="lazy"
      decoding="async"
      alt=""
      width="35"
      height="35"
    >
    <Heading
      :level="props.headingLevel"
      class="mb-2 epsilon"
    >
      {{ props.item.title }}
    </Heading>
    <Typo
      v-if="props.item.description"
      class="mb-4"
    >
      <div
        class="fs-smaller"
        v-html="props.item.description"
      />
    </Typo>
    <a
      v-if="props.item.cta_button.link"
      :href="props.item.cta_button.link"
      :target="props.item.cta_button.isExternal ? '_blank' : '_self'"
      class="d-block overflow-hidden stretched-link"
      @click="handleClick"
    >
      <span
        class="product-box-colored-more d-inline-block position-relative transition fs-smaller text-secondary fw-bolder text-decoration-underline"
      >
        {{ props.item.cta_button.text }}
        <svg
          aria-hidden="true"
          class="ms-1 transition"
          width="12"
          height="9"
        >
          <use xlink:href="#angle-right" />
        </svg>
      </span>
    </a>
  </article>
</template>
<style lang="scss" scoped>
@import './ProductBoxColored.scss';
</style>
